import { type FirebaseOptions, getApps, initializeApp } from 'firebase/app'
import { type Auth, type User, getAuth } from 'firebase/auth'

import {
  PUBLIC_FIREBASE_API_KEY,
  PUBLIC_FIREBASE_AUTH_DOMAIN,
} from '$env/static/public'

const firebaseConfig: FirebaseOptions = {
  apiKey: PUBLIC_FIREBASE_API_KEY,
  authDomain: PUBLIC_FIREBASE_AUTH_DOMAIN,
}
export const initFirebaseAuth = async () => {
  const app = getApps()[0] || initializeApp(firebaseConfig)
  const auth = getAuth(app)
  return auth
}

export async function getFirebaseAuthUser(auth: Auth) {
  const user = await new Promise<User | null>((resolve, reject) => {
    let timeout: ReturnType<typeof setTimeout> | null = null

    const unsub = auth.onAuthStateChanged(a => {
      resolve(a)
      unsub()
      if (timeout) clearTimeout(timeout)
    })

    timeout = setTimeout(() => {
      reject(new Error('❗️ Auth timeout'))
      unsub()
    }, 5000)
  })
  return user
}
